export interface IEPF_FORMULA {
  presentAge: number;
  monthlySalDA: number;
  epfContribution: number;
  employerContribution: number;
  retirementAge: number;
  currentEPF: number;
  currentInterest: number;
}
export const EPF_FORMULA = ({
  presentAge,
  monthlySalDA,
  epfContribution,
  employerContribution,
  retirementAge,
  currentEPF,
  currentInterest,
}: IEPF_FORMULA) => {
  if (
    presentAge < 15 ||
    presentAge > 60 ||
    monthlySalDA < 0 ||
    monthlySalDA > 15e3 ||
    epfContribution < 12 ||
    epfContribution > 100 ||
    retirementAge < 20 ||
    retirementAge > 58 ||
    retirementAge < presentAge ||
    currentEPF < 0 ||
    currentEPF > 1e10
  ) {
    const res = 0;
    return {
      epfOutput: res,
    };
  }
  const presAge = Number(presentAge);
  const monSalaryDA = Number(monthlySalDA);
  const epfContri = Number(epfContribution);
  const employerContri = Number(employerContribution);
  const retireAge = Number(retirementAge);
  const currEPF = Number(currentEPF);
  const currInterest = Number(currentInterest);

  const monthlyEPFContri = Math.round(
    monSalaryDA * (epfContri / 100 + employerContri / 100)
  );
  const durationInvestment = retireAge - presAge;

  const rate = currInterest / 100;
  const term = Math.pow(1 + currInterest / 100, durationInvestment);
  const payment = monthlyEPFContri * 12;
  const futureValue =
    currEPF * term + (payment * (1 + rate) * (term - 1)) / rate;

  return {
    epfOutput: futureValue.toFixed(0),
  };
};
